<template>
  <router-view></router-view>
</template>

<script>
import Swal from "sweetalert2";
import endpoint from "./Commons/Services";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      timer: 2 * (60 * 1000),
      seconds: 0,
      minutes: 0,
      count: null,
    };
  },
  watch: {
    $route: function (newVal, oldVal) {
      if (newVal.name !== "") {
        let path = newVal;
        let expired =
          localStorage.getItem("dp-expired") === "true" ? true : false;
        if (path.meta.requiresAuth && expired) {
          this.logoOut();
        } else if (!path.meta.requiresAuth) {
          localStorage.setItem("dp-expired", false);
        }
      }
    },
    isIdle: {
      handler: async function (current, old) {
        if (current) {
          if (this.$route.meta.requiresAuth) {
            await this.alertSesion();
          }
        }
      },
      deep: true,
    },
    sigout: {
      handler: async function (current, old) {
        if (current) {
          if (this.$route.meta.requiresAuth) {
            localStorage.setItem("dp-expired", true);
            await this.sesionFinish();
          }
        }
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    async alertSesion() {
      try {
        this.seconds = 59;
        this.minutes = 1;
        let result = await Swal.fire({
          title: "Are you still there?",
          html: "For your security, <br> your Rhombuss session expires after 4 hours. <br> You current session is about to expire in <b><strong>02:00</strong></b minutes. <br> Do you want to save changes?",
          imageUrl: "../img/icons/alerts/warning.png",
          buttonsStyling: false,
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          cancelButtonText: "Continue with my session",
          confirmButtonText: "Logo out now and end my session",
          customClass: {
            confirmButton: "btn btn-link",
            cancelButton: "btn btn-link",
          },
          timer: this.timer,
          onOpen: () => {
            this.count = setInterval(() => {
              if (this.seconds === 0) {
                this.minutes = this.minutes - 1;
                this.seconds = 60;
              }
              this.seconds = this.seconds - 1;
              Swal.getContent().querySelector(
                "strong"
              ).textContent = `${this.parsertime(
                this.minutes
              )}:${this.parsertime(this.seconds)}`;
            }, 1000);
          },
          onClose: () => {
            clearInterval(this.count);
          },
        });
        if (result.value) {
          localStorage.setItem("dp-expired", true);
          this.logoOut();
        } else if (result.dismiss === "timer") {
          localStorage.setItem("dp-expired", true);
          this.sesionFinish();
        } else if (result.dismiss === "cancel") {
          let { data } = await endpoint.auth.services.restoreToken(
            this.sesion.id,
            this.sesion.role,
            this.sesion.account_type
          );
          if (data.status) {
            let sesion = data.data;
            if (sesion.token) {
              data["status"] = true;
              localStorage.setItem("dp-sesion", JSON.stringify(sesion));
              this.setSesion(sesion);
              this.setSigOut(false);
            } else {
              localStorage.setItem("dp-expired", true);
              this.setSigOut(false);
              this.logoOut();
            }
          } else {
            localStorage.setItem("dp-expired", true);
            this.setSigOut(false);
            this.logoOut();
          }
        }
      } catch (error) {
        localStorage.setItem("dp-expired", true);
        this.setSigOut(false);
        this.logoOut();
      }
    },
    async sesionFinish() {
      let result = await Swal.fire({
        title: "Your session has expired",
        html: "For you security your current session has expired and you have been logged out. ",
        imageUrl: "../img/icons/alerts/warning.png",
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "",
        confirmButtonText: "Accept",
        customClass: {
          confirmButton: "btn btn-primary btn-small",
          cancelButton: "btn btn-link",
        },
      });
      if (result.value) {
        this.setSigOut(false);
        this.logoOut();
      }
    },

    logoOut() {
      localStorage.removeItem("dp-sesion");
      localStorage.removeItem("dp-duplicate");
      this.$router.push("/login");
    },
    parsertime(time) {
      if ((time >= 0) & (time < 10)) {
        return `0${time}`;
      } else {
        return time;
      }
    },
    ...mapMutations([
      "setSesion",
      "setResponseReservations",
      "setResponseSupplier",
      "setResponseBranch",
      "setSigOut",
    ]),
  },
  computed: {
    ...mapState(["sesion", "sigout"]),
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
};
</script>
